/**
 * Frozen feature-flag contracts. This file stays free of imports so the PR
 * check can load it with Node alone.
 *
 * Component constants do not belong here. Pass them to useFeatureFlag as
 * `options` at the call site.
 */

const FX_SINGLE_SEARCH_ENABLED = Object.freeze({
    id: 'FX_SINGLE_SEARCH_ENABLED',
    flagKey: 'fx-single-search',
    values: Object.freeze({
        OFF: false,
        ON: true
    }),
    sfcc: Object.freeze({
        preferenceId: 'fxSingleSearchEnabled',
        preferenceGroup: 'featureSwitchers',
        preferenceType: 'boolean',
        defaultValue: false
    })
})

const VICKY_FYPRECOS_PLPENABLED = Object.freeze({
    id: 'VICKY_FYPRECOS_PLPENABLED',
    flagKey: 'fx-vicky-fyprescosp-plp-enabled',
    values: Object.freeze({
        OFF: false,
        ON: true
    }),
    sfcc: Object.freeze({
        preferenceId: 'vickyFYPRecosPLPEnabled',
        preferenceGroup: 'featuresSwitchers',
        preferenceType: 'boolean',
        defaultValue: false
    })
})
module.exports = {
    FX_SINGLE_SEARCH_ENABLED,
    VICKY_FYPRECOS_PLPENABLED
}
